import {AppointmentNote} from './appointment-note.model';
import {AppointmentType} from '../utility/appointment-type.enum';
import {Specialty} from '../utility/speciality.enum';
import {Patient} from './patient.model';

export class Appointments {
  id?: number;
  externalId: string;
  apptType: AppointmentType;
  doctorName: string;
  doctorSpecialty: Specialty;
  apptDate: Date;
  venue: string;
  description?: string;
  markedAsGoing?: boolean;
  notGoingReason?: string;
  patientId: number;
  appointmentNotes: AppointmentNote[];
  patient?: Patient;
  checkInDate?: Date;
  checkOutDate?: Date;
  absenceReason?: string;
  careTeamNote?: string;
  checkinBtnClass?: string;
  checkinBtnStatus?: string;
  badgeText?: string;
  badgeStatus?: string;
  appntImage?: string;
  patientName?: string;
  patientImageUrl?: string;
  cancerType?: string;
  patientImg?: string;
  patientLastName?: string;
}
export class GetAppoinmentModel {
  id?: number;
  externalId: string;
  apptType: AppointmentType;
  doctorName: string;
  doctorId?: number;
  doctorSpecialty: Specialty;
  apptDate: Date;
  venue: string;
  description?: string;
  markedAsGoing?: boolean;
  notGoingReason?: string;
  patientId: number;
  appointmentNotes: AppointmentNote[];
  patient?: Patient;
  checkInDate?: Date;
  checkOutDate?: Date;
  absenceReason?: string;
  careTeamNote?: string;
  checkinBtnClass?: string;
  checkinBtnStatus?: string;
  badgeText?: string;
  badgeStatus?: string;
  appntImage?: string;
  status?: string;
  startsIn?: string;
  patientImageUrl?: string;
  patientName?: string;
  appointmentTimeSlotValue?: string;
  appointmentDateValue?: string;
  appointmentTime?: string;
  patientImg?: string;
  webexUrl?: string;
  userType?: string;
  patientFirstName?: string;
  patientLastName?: string;
  patientType?: string;
  cancerType?: string;
  appointmentDate?: any;
}
